import { skills } from '../skill'
import { describeTable } from './describeTable'

describeTable(skills, {
  description:
    'Master list of skills (e.g. nuohous, IV-puhdistus, kattotyöt) that can be attached to employees through employee_skills. Maintained by hand in the ERP configuration; name is unique. Do not confuse with maintenance_tasks (the service catalogue) or employees.bookable_service_presets (what the widget may book).',
  columns: {
    category: 'Free-text grouping of skills; optional.',
  },
})
